import React, { Fragment, ReactElement } from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import { Divider } from '@material-ui/core';
import { Translations } from './../../configuration';
import * as CurrencyUtils from 'utils/currency';
import useStyles from './styles';
import Box from '@material-ui/core/Box';
import * as DateUtils from '../../../../utils/dates';

export default function VatReturnReceivedInfoModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_VAT_RETURN_RECEIVED_DETAILS_VIEW}
      renderHeader={({ header, data }: IModalProps) => (
        <VatReturnReceivedInfoHeader header={header} data={data} />
      )}
      renderContent={({ header, data }: IModalProps) => (
        <React.Fragment>
          <VatReturnReceivedInfoBody header={header} data={data} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  data: any;
}

const VatReturnReceivedInfoHeader = ({ header, data }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const VatReturnReceivedInfoBody = ({ header, data }: IModalProps) => {
  const classes = useStyles();
  return (
    <Fragment>
      <h3>
        <TranslatedText textMap={Translations.vat_return_details_title} />
      </h3>
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.version} />
          <div>{data.version}</div>
        </Box>
      </div>
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.change_date} />
          <div>{data.change_date}</div>
          {/* <div>{DateUtils.formatDateTimeSeconds(data.change_date)}</div> */}
        </Box>
      </div>
      <Divider className={classes.divide} />
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.total_msid_services} />
          <div className={classes.service_goods_value}>
            {CurrencyUtils.formatCurrency(data.total_msid_services)}
          </div>
        </Box>
      </div>
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.total_msid_goods} />
          <div className={classes.service_goods_value}>
            {CurrencyUtils.formatCurrency(data.total_msid_goods)}
          </div>
        </Box>
      </div>
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.total_msest_services} />
          <div className={classes.service_goods_value}>
            {CurrencyUtils.formatCurrency(data.total_msest_services)}
          </div>
        </Box>
      </div>
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.total_msest_goods} />
          <div className={classes.service_goods_value}>
            {CurrencyUtils.formatCurrency(data.total_msest_goods)}
          </div>
        </Box>
      </div>
      <div className={classes.service_goods_container}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <TranslatedText textMap={Translations.total_corrections} />
          <div className={classes.service_goods_value}>
            {CurrencyUtils.formatCurrency(data.total_corrections)}
          </div>
        </Box>
      </div>

      {/* <BlueBlockQuote>
        <div className={classes.container}>
          <TranslatedText textMap={Translations.total_corrections} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(data.total_corrections)}
          </div>
        </div>
      </BlueBlockQuote> */}
      <YellowBlockQuote>
        <div className={classes.container}>
          <TranslatedText textMap={Translations.total_vat_amount} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(data.grand_total)}
          </div>
        </div>
      </YellowBlockQuote>
      <GreenBlockQuote>
        <div className={classes.container} style={{ fontWeight: 'bold' }}>
          <TranslatedText textMap={Translations.total_vat_amount_payable} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(data.balance_of_vat_value)}
          </div>
        </div>
      </GreenBlockQuote>
      <Divider className={classes.divide} />

      {data.paymentDetails.length > 0 && (
        <h3>
          <TranslatedText textMap={Translations.payment_details_title} />
        </h3>
      )}
      {data.paymentDetails.map((data: any, index: number) => {
        return (
          <div className={classes.service_goods_container} key={index}>
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <span>
                Payment on {DateUtils.formatDate(data.payment_date_applicant)}{' '}
                received with {data.payment_reference_number} (€):
              </span>
              {/* <TranslatedText textMap={Translations.total_corrections} /> */}
              <div className={classes.service_goods_value}>
                {CurrencyUtils.formatCurrency(data.vat_amount_received)}
              </div>
            </Box>
          </div>
        );
      })}

      <BlueBlockQuote>
        <div className={classes.container}>
          <TranslatedText textMap={Translations.total_vat_amount_paid} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(data.total_vat_amount_paid)}
          </div>
        </div>
      </BlueBlockQuote>
      <YellowBlockQuote>
        <div className={classes.container}>
          <TranslatedText
            textMap={Translations.total_amount_to_be_reimbursed}
          />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(data.total_amount_to_be_reimbursed)}
          </div>
        </div>
      </YellowBlockQuote>
      <GreenBlockQuote>
        <div className={classes.container}>
          <TranslatedText textMap={Translations.total_amount_reimbursed} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(data.total_amount_reimbursed)}
          </div>
        </div>
      </GreenBlockQuote>
    </Fragment>
  );
};

interface BlockQuote {
  children: any;
}
function BlueBlockQuote(props: BlockQuote) {
  const styles = useStyles();
  return <div className={styles.quote_block_blue}>{props.children}</div>;
}

function YellowBlockQuote(props: BlockQuote) {
  const styles = useStyles();
  return <div className={styles.quote_block_yellow}>{props.children}</div>;
}

function GreenBlockQuote(props: BlockQuote) {
  const styles = useStyles();
  return <div className={styles.quote_block_green}>{props.children}</div>;
}
